<template>
  <el-card class="case-detail">
    <el-descriptions
      :column="2">
      <el-descriptions-item label="案件号">{{ ruleForm.ah }}</el-descriptions-item>
      <el-descriptions-item label="案件进展阶段">{{ ruleForm.ajjzjd }}</el-descriptions-item>
      <el-descriptions-item label="立案日期">{{ ruleForm.larq | dateformat('YYYY-MM-DD') }}</el-descriptions-item>
      <el-descriptions-item label="立案案由">{{ ruleForm.laay || '-' }}</el-descriptions-item>
      <el-descriptions-item label="经办法院">{{ ruleForm.jbfy || '-' }}</el-descriptions-item>
      <el-descriptions-item label="判决结果">{{ ruleForm.pjjg || '-' }}</el-descriptions-item>
      <el-descriptions-item label="案件类型">{{ ruleForm.type || '-' }}</el-descriptions-item>
      <el-descriptions-item label="诉讼地位">{{ ruleForm.ssdw || '-' }}</el-descriptions-item>
      <el-descriptions-item label="起诉标的金额">{{ ruleForm.qsbdje || '-' }}{{ ruleForm.qsbdje ? '元' : '' }}</el-descriptions-item>
      <el-descriptions-item label="结案标的金额">{{ ruleForm.jabdje || '-' }}{{ ruleForm.jabdje ? '元' : '' }}</el-descriptions-item>
      <el-descriptions-item label="当事人列表">
        <el-table
          border
          :data="ruleForm.dsrs">
          <el-table-column
            label="名称"
            prop="mc"
            min-width="100"></el-table-column>
          <el-table-column
            label="诉讼地位"
            prop="ssdw"
            min-width="120"></el-table-column>
          <el-table-column
            label="当事人类型"
            prop="dsrlx"
            min-width="120"></el-table-column>
        </el-table>
      </el-descriptions-item>
    </el-descriptions>
  </el-card>
</template>

<script>
export default {
  name: 'CaseDetail',
  props: {
    ruleForm: { type: Object, default: () => {} }
  }
}
</script>
<style lang="stylus" scoped>

</style>
